const rolesConstants = {
  // Usuarios finales (humano de a pie)
  ROLE_FINALCUSTOMER: 'ROLE_FINALCUSTOMER',
  // Usuarios
  ROLE_OPERATOR: 'ROLE_OPERATOR',
  ROLE_COMMERCIAL: 'ROLE_COMMERCIAL',
  ROLE_MERCHANT: 'ROLE_MERCHANT',
  ROLE_MERCHANTCOM: 'ROLE_MERCHANTCOM',
  ROLE_MERCHANTADMIN: 'ROLE_MERCHANTADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_USER: 'ROLE_USER',
  ROLE_ACCOUNTANT: 'ROLE_ACCOUNTANT',
  ROLE_VIEWER: 'ROLE_VIEWER',
  ROLE_SUPERVISOR: 'ROLE_SUPERVISOR',
  ROLE_FINANCEANALYST: 'ROLE_FINANCEANALYST',
  ROLE_LENDER: 'ROLE_LENDER',
}

export const rolesActionsConstants = {
  ROLE_OPERATOR: 'OPERATOR',
  ROLE_MERCHANT: 'MERCHANT',
  ROLE_ADMIN: 'ADMIN',
  ROLE_USER: 'CUSTOMER',
  ROLE_VIEWER: 'VIEWER',
  ROLE_SUPERVISOR: 'SUPERVISOR',
  ROLE_ENTERPRISEADMIN: 'ENTERPRISEADMIN',
  ROLE_FINANCEANALYST: 'FINANCEANALYST',
  ROLE_ACCOUNTANT: 'ACCOUNTANT',
}

export const merchantCreationRoles = ['MERCHANT', 'MERCHANTCOM', 'MERCHANTADMIN', 'SUPERVISOR']

export const supervisorCreationRoles = ['SUPERVISOR']

export const agentCreationRoles = [
  'COMMERCIAL',
  'OPERATOR',
  'ACCOUNTANT',
  'ADMIN',
  'VIEWER',
  'FINANCEANALYST',
  'LENDER',
]

export default rolesConstants
